import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import SettingsSection from '../../../components/settingsSection/SettingsSection'
import { Building2, Fingerprint, Lock } from 'lucide-react'

export default function AzureAdServicePrincipalSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Tenant ID"
          icon={<Building2 size={16} />}
          value={watch('azure_ad_sp.tenantId') || ''}
          onChange={(value) => setValue('azure_ad_sp.tenantId', value)}
          placeholder="00000000-0000-0000-0000-000000000000"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Client ID"
          icon={<Fingerprint size={16} />}
          description="This app must be granted access in the Fabric workspace and the SQL endpoint - see the setup guide below."
          value={watch('azure_ad_sp.clientId') || ''}
          onChange={(value) => setValue('azure_ad_sp.clientId', value)}
          placeholder="Application (client) ID"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="Client Secret"
          icon={<Lock size={16} />}
          value={watch('azure_ad_sp.clientSecret') || ''}
          onChange={(value) => setValue('azure_ad_sp.clientSecret', value)}
          autoComplete="new-password"
          skipPasswordValidation={true}
          className={styles.input}
        />
      </div>

      <SettingsSection
        title="How to set up the Entra ID app"
        collapsible
        defaultExpanded={false}
      >
        <ol className={styles.helpList}>
          <li>
            Azure Portal → Entra ID → App registrations → New registration. Create a client
            secret, and note the Tenant ID, Client (Application) ID, and the secret.
          </li>
          <li>
            Add the app to the Fabric workspace (workspace → Manage access). This requires the
            tenant's Fabric admin setting "service principals can call Fabric APIs" to be enabled.
          </li>
          <li>
            Required one-time SQL grant — this can't be done from this page. Someone with Entra
            ID access to the endpoint (e.g. via SSMS or Azure Data Studio) must run once:
            <pre className={styles.helpCode}>
{`CREATE USER [<app-display-name>] FROM EXTERNAL PROVIDER;
ALTER ROLE db_datareader ADD MEMBER [<app-display-name>];`}
            </pre>
            Without this grant, the service principal authenticates but every query fails on
            permissions.
          </li>
          <li>Come back here, fill in Tenant ID / Client ID / Client Secret, and use Test Connection.</li>
        </ol>
      </SettingsSection>
    </>
  )
}
